import { FinalizarGrupoFormativoExport } from './finalizar-grupo-formativo'

export function FundaeComponent() {
  // This indirection is here just to facilitate later the usage of tabs
  return <FinalizarGrupoFormativoExport />
}
